exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FRYV1WSXWdV9IDn5NzEj-{display:-webkit-box;display:-ms-flexbox;display:flex;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] .FRYV1WSXWdV9IDn5NzEj-{border-bottom:1px solid \"[theme:neutralTertiaryAlt, default:#c8c8c8]\";padding:0 5px 5px;margin-bottom:5px}.Ub0hyxKDSW-WmeLksSnv8{-webkit-box-flex:1;-ms-flex:1;flex:1}.Ub0hyxKDSW-WmeLksSnv8 a{color:\"[theme:themePrimary, default:#0078D7]\"}", ""]);

// exports
exports.locals = {
	"container": "FRYV1WSXWdV9IDn5NzEj-",
	"resetButton": "Ub0hyxKDSW-WmeLksSnv8"
};